export enum AnalyzerProbabilityCalculationMode {
    None,
    Single,
    OR,
    AND
}
